class ProductParamsEV {
    constructor({
        yearRun,
        schedule,
        scheduleValue,
    }) {
        this.yearRun = yearRun
        this.schedule = schedule
        this.scheduleValue = scheduleValue
    }

    toJSON = () => ({
        yearRun: this.yearRun,
        schedule: this.schedule,
        scheduleValue: this.scheduleValue,
    })
}

export default ProductParamsEV
